import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Container, Row, Col, Nav, Card, Toast, ToastContainer } from 'react-bootstrap';
import { FaUser, FaLock, FaBell, FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { useSettings } from '../../../context/SettingsContext';
import '../../../assets/css/admin/adminSettings/adminsettings.css';

const AdminSettingsLayout = () => {
  const { toast } = useSettings();

  const navItems = [
    { path: '/admin/settings/profile', label: 'Profile', icon: FaUser },
    { path: '/admin/settings/password', label: 'Password', icon: FaLock },
    { path: '/admin/settings/notifications', label: 'Notifications', icon: FaBell }
  ];

  return (
    <div className="adm-settings-container">
      <Container fluid>
        {/* Header */}
        <div className="adm-settings-header">
          <h1>Settings</h1>
          <p>Manage your account settings and preferences</p>
        </div>

        <Row>
          <Col lg={3} md={4} className="mb-4">
            <Card className="adm-settings-nav-card">
              <Card.Body>
                <Nav className="flex-column adm-settings-nav">
                  {navItems.map(item => {
                    const IconComponent = item.icon;
                    return (
                      <NavLink
                        key={item.path}
                        to={item.path}
                        className={({ isActive }) =>
                          `adm-settings-nav-link ${isActive ? 'adm-settings-nav-active' : ''}`
                        }
                      >
                        <IconComponent className="adm-settings-nav-icon" />
                        <span>{item.label}</span>
                      </NavLink>
                    );
                  })}
                </Nav>
              </Card.Body>
            </Card>
          </Col>

          {/* Content Area */}
          <Col lg={9} md={8}>
            <Outlet />
          </Col>
        </Row>
      </Container>

      {/* Toast Notifications */}
      <ToastContainer position="top-end" className="p-3">
        <Toast
          show={toast.show}
          bg={toast.type === 'success' ? 'success' : toast.type === 'error' ? 'danger' : 'warning'}
          autohide
          delay={3000}
        >
          <Toast.Body className="d-flex align-items-center text-white">
            {toast.type === 'success' ? (
              <FaCheckCircle className="me-2" />
            ) : (
              <FaExclamationTriangle className="me-2" />
            )}
            <span>{toast.message}</span>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default AdminSettingsLayout;